export function interpolatePrice(view: number, viewMarks: { view: number; price: number }[]): number | null {
	for (let i = 0; i < viewMarks.length - 1; i++) {
		const lowerMark = viewMarks[i];
		const upperMark = viewMarks[i + 1];

		if (view >= lowerMark.view && view <= upperMark.view) {
			const proportion = (view - lowerMark.view) / (upperMark.view - lowerMark.view);
			return Math.round(lowerMark.price + proportion * (upperMark.price - lowerMark.price));
		}
	}
	if (view === viewMarks[viewMarks.length - 1].view) {
		return viewMarks[viewMarks.length - 1].price;
	}
	return null;
}

export function interpolateView(price: number, viewMarks: { view: number; price: number }[]): number | null {
	for (let i = 0; i < viewMarks.length - 1; i++) {
		const lowerMark = viewMarks[i];
		const upperMark = viewMarks[i + 1];

		if (price >= lowerMark.price && price <= upperMark.price) {
			const proportion = (price - lowerMark.price) / (upperMark.price - lowerMark.price);
			return Math.round(lowerMark.view + proportion * (upperMark.view - lowerMark.view));
		}
	}
	if (price === viewMarks[viewMarks.length - 1].price) {
		return viewMarks[viewMarks.length - 1].view;
	}
	return null;
}
